export default {
  合同管理信息列表: "合同管理信息列表",
  申请合同审查: "申请合同审查",
  合同审查申请: "合同审查申请",
  合同基础信息: "合同基础信息",
  供应商编号: "供应商编号",
  请选择供应商: "请选择供应商",
  供应商名称中文: "供应商名称（中文）",
  供应商名称英文: "供应商名称（英文）",
  自动带出: "自动带出",
  合同名称: "合同名称",
  请输入合同名称: "请输入合同名称",
  请输入: "请输入",
  合同编号: "合同编号",
  请输入合同编号: "请输入合同编号",
  合同总金额币种: "合同总金额/币种",
  请输入合同金额: "请输入合同金额",
  请选择币种: "请选择币种",
  合同有效期: "合同有效期",
  请选择合同有效期: "请选择合同有效期",
  合同主要内容: "合同主要内容",
  请输入合同主要内容: "请输入合同主要内容",
  合同文件: "合同文件",
  相关文件: "相关文件",
  合同文件信息: "合同文件信息",
  双方已签署合同: "双方已签署合同",
  合同相关附件: "合同相关附件",
  KMS合同文件编号: "KMS合同文件编号",
  请输入KMS合同文件编号: "请输入KMS合同文件编号",
  申请人信息: "申请人信息",
  申请人: "申请人",
  请选择申请人: "请选择申请人",
  部门: "部门",
  部门主管: "部门主管",
  工厂: "工厂",
  请选择工厂: "请选择工厂",
  合同来源: "合同来源",
  请选择合同来源: "请选择合同来源",
  已批准采购申请表编号: "已批准采购申请表编号",
  附件上传: "附件上传",
  合同审查信息: "合同审查信息",
  合同类别: "合同类别",
  请选择合同类别: "请选择合同类别",
  合同子类别: "合同子类别",
  请选择合同子类别: "请选择合同子类别",
  合同描述: "合同描述",
  请输入合同描述: "请输入合同描述",
  合同审查项: "合同审查项",
  合同检查项: "合同检查项",
  公司标准: "公司标准",
  实际: "实际",
  请选择: "请选择",
  请输入备注: "请输入备注",
  合同上传方: "合同上传方",
  流程状态: "流程状态",
  当前节点: "当前节点",
  供应商: "供应商",
  供应商名称: "供应商名称",
  用户部门: "用户部门",
  操作: "操作",
  编辑: "编辑",
  查看: "查看",
  重新提交: "重新提交",
  删除: "删除",
  草稿: "草稿",
  已驳回: "已驳回",
  审批中: "审批中",
  已存档: "已存档",
  暂存: "暂存",
  提交: "提交",
  关闭: "关闭",
  审批成功: "审批成功",
  暂存已提交: "暂存已提交",
  申请已提交: "申请已提交",
  提交成功: "提交成功",
  供应商提供: "供应商提供",
  删除成功: "删除成功",
  BF合同模版: "BF合同模版",
  常规服务年度合同更新与同一供应商续签:
    "常规服务年度合同更新(与同一供应商续签)",
  不能提供合同但有采购订单必须说明理由:
    "不能提供合同但有采购订单(必须说明理由)",
  "未上传合同：查询不到目标文件，请先上传合同":
    "未上传合同：查询不到目标文件，请先上传合同",
  "合同正在审核，请耐心等待": "合同正在审核，请耐心等待",
  合同审核失败: "合同审核失败",
  查看AI审核结果: "查看AI审核结果",
  合同审核: "合同审核",
  AI审核: "AI审核",
  审查结果: "审查结果",
  高: "高",
  中: "中",
  低: "低",
  暂无: "暂无",
  检测结果为空: "检测结果为空",
  存在问题: "存在问题",
  建议修改内容: "建议修改内容",
  风险程度: "风险程度",
  检测正常: "检测正常",
};
